export default "__VITE_ASSET__DfZcvUNB__"